import React, { useEffect, useRef, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import '../../assignment.scss'
import { actions } from '../../../../store/reducers/assignment.reducer'
import Query from '../../../../components/common/query-section/Query'
import GenerateSimilarSubmissionsModal from '../generate-similar-submissions-modal/GenerateSimilarSubmissionsModal'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'
import ResizableDrawer from '../../../../components/common/resizable-drawer/ResizableDrawer'
import FileDrawerFooter from './FileDrawerFooter'
import FileDrawerHeader from './FileDrawerHeader'
import FileDrawerNavigation from './FileDrawerNavigation'
import FileDrawerContent from './FileDrawerContent'
import submissionSelectors from '../../../../store/selectors/submission.selectors'
import { Skeleton } from 'antd'

const FileDrawer = ({ clusters, drawer, setShowDrawer, setDrawerFile, setShowQueryEditor, isExcelAssignment }) => {
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)
    const showGenerateSimilarSubmissionsModal = useSelector(assignmentSelectors.showGenerateSimilarSubmissionsModal)
    const [animationOfDrawerHasFinished, setAnimationOfDrawerHasFinished] = useState(false)
    const showQueryEditorRef = useRef(drawer.showQueryEditor)

    useEffect(() => {
        if (drawer.showDrawer) {
            const fileToSet = clusters
                .map(cluster => cluster.files)
                .flat()
                .find(file => parseInt(file.id) === openedSubmissionId)
            if (fileToSet) setDrawerFile(fileToSet)
        }
    }, [clusters])

    const handleClose = () => {
        setShowDrawer(false)
    }

    useEffect(() => {
        return () => {
            setDrawerFile({})
            setShowQueryEditor(false)
            handleClose()
        }
    }, [])

    useEffect(() => {
        showQueryEditorRef.current = drawer.showQueryEditor
    }, [drawer.showQueryEditor])

    return (
        <ResizableDrawer
            autofocus
            className='file-drawer'
            title={<FileDrawerHeader />}
            placement='right'
            size='large'
            onClose={handleClose}
            destroyOnClose
            open={drawer.showDrawer}
            mask={false}
            maskClosable={false}
            extra={<FileDrawerNavigation />}
            footer={<FileDrawerFooter />}
            afterOpenChange={() => setAnimationOfDrawerHasFinished(true)}
        >
            {showGenerateSimilarSubmissionsModal && <GenerateSimilarSubmissionsModal />}
            <div
                id='editor-container'
                style={
                    isExcelAssignment()
                        ? null
                        : {
                              maxHeight: `calc(100vh - ${drawer.showQueryEditor ? 348 : 168}px)`,
                              overflowY: 'auto',
                          }
                }
            >
                {animationOfDrawerHasFinished ? <FileDrawerContent /> : <Skeleton />}
            </div>
            {drawer.showQueryEditor && <Query />}
        </ResizableDrawer>
    )
}

const mapState = ({ assignment }) => {
    return {
        assignment: assignment.assignment,
        clusters: assignment.clusters,
        drawer: assignment.drawer,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowDrawer(value) {
            dispatch(actions.setShowDrawer(value))
        },
        setDrawerFile(value) {
            dispatch(actions.setDrawerFile(value))
        },
        setShowQueryEditor(value) {
            dispatch(actions.setShowQueryEditor(value))
        },
        isExcelAssignment() {
            return dispatch(actions.isExcelAssignment())
        },
    }
}

export default connect(mapState, mapDispatch)(FileDrawer)
